import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CampaignGame } from "./CampaignGame";
import { App } from "./App";
import { WorkshopPreviewApp } from "./WorkshopPreviewApp";
import "./index.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found");
}

/**
 * Phase 14 (Master Spec §33/§34/§36) — a Workshop level preview is a
 * completely separate top-level render tree from the authenticated
 * player flow `<App>` owns (BOOT → LOGIN → SYNC → PLAY), not a new
 * `screen` value inside it: a preview has no signed-in user, submits no
 * attempts, and never touches auth/sync at all, so folding it into
 * `appStore`'s `AppScreen` union would mean every consumer of that type
 * (including the real player flow) now has to reason about a state that
 * means something structurally different. `?workshopPreview=<encoded
 * JSON>` in the URL is what selects it — see `WorkshopPreviewApp.tsx`'s
 * own doc comment for why passing the level data through the URL
 * (rather than an authenticated fetch) is this phase's actual design
 * decision, not just a routing detail.
 */
const previewParam = new URLSearchParams(window.location.search).get("workshopPreview");

createRoot(container).render(
  <StrictMode>{previewParam ? <WorkshopPreviewApp encoded={previewParam} /> : new URLSearchParams(window.location.search).get("campaignPreview") === "1" ? <CampaignGame userId={null} /> : <App />}</StrictMode>,
);
